import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

const Api = {
  Action_List: baseDomain + '/action/page', // 动作列表
  Action_Detail: baseDomain + '/action/', // 动作详情
  Action_Add: baseDomain + '/action/create', // 动作添加
  Action_Delete: baseDomain + '/action/', // 动作删除
  Action_Edit: baseDomain + '/action/update', // 动作编辑
  Action_Parse: baseDomain + '/action/parseFile', // 动作解析

  Device_List: baseDomain + '/embody/device/list', // 可选设备列表
  Deploy_Action: baseDomain + '/deploy/action', // 动作下发
  Deploy_Precheck: baseDomain + '/deploy/precheck', // 设备预检
}

export const reqActionList = (params) => {
  return service({
    url: Api.Action_List,
    method: 'POST',
    data: params
  })
}
export const reqActionDetail = (id) => {
  return service({
    url: Api.Action_Detail + id,
    method: 'GET',
  })
}
export const reqActionAdd = (params) => {
  return service({
    url: Api.Action_Add,
    method: 'POST',
    data: params
  })
}
export const reqActionEdit = (params) => {
  return service({
    url: Api.Action_Edit,
    method: 'PUT',
    data: params
  })
}
export const reqActionDelete = (id) => {
  return service({
    url: Api.Action_Delete + id,
    method: 'DELETE',
  })
}
export const reqActionParse = (params) => {
  return service({
    url: Api.Action_Parse,
    method: 'POST',
    data: params
  })
}

export const reqDeviceList = () => {
  return service({
    url: Api.Device_List,
    method: 'POST',
    data: {}
  })
}
export const reqDeployAction = (params) => {
  return service({
    url: Api.Deploy_Action,
    method: 'POST',
    data: params
  })
}
export const reqDeployPrecheck = (params) => {
  return service({
    url: Api.Deploy_Precheck,
    method: 'POST',
    data: params
  })
}
